import { render, staticRenderFns } from "./InAppSurvey.vue?vue&type=template&id=9f79a8f0&scoped=true"
import script from "./InAppSurvey.vue?vue&type=script&lang=ts"
export * from "./InAppSurvey.vue?vue&type=script&lang=ts"
import style0 from "./InAppSurvey.vue?vue&type=style&index=0&id=9f79a8f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f79a8f0",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
